import React from 'react';

const IterativeStatsWidget = ({ stats }) => {
  const groupStats = (stats) => {
    const groups = {
      published: [],
      submissions: [],
      ftc: [],
      totals: [],
      approval: [],
      publication: [],
      deferralRanges: []
    };

    const positionRanges = [
      { range: [0, 5], key: 'published' },
      { range: [5, 10], key: 'submissions' },
      { range: [11, 18], key: 'totals' },
      { range: [18, 26], key: 'approval' },
      { range: [26, 33], key: 'publication' },
    ];

    stats.forEach(stat => {
      if (stat.mapColumn != null) {
        Object.entries(stat).forEach(([label, total]) => {
          if(label !== 'mapColumn') {
            groups[stat.mapColumn].push({label, total})
          }
        });
        return;
      }

      for (const { range, key } of positionRanges) {
        if (stat.position >= range[0] && stat.position < range[1]) {
          groups[key].push(stat);
          break;
        }
      }
    });

    return groups;
  };


  const renderStatRow = (group) => (
    <tr>
      {group.map((e, i) => (
        <td key={i}>
          <strong>{e.total}</strong><br />
          <h5 className="reg">{e.label}</h5>
        </td>
      ))}
    </tr>
  );

  const groups = groupStats(stats);

  return (
    <table className="editorial-widget">
      <tbody>
        <tr>
          <td><h6>Published</h6></td>
        </tr>
        {renderStatRow(groups.published)}
        <tr>
          <td><h6>Submissions</h6></td>
        </tr>
        {renderStatRow(groups.submissions)}
        <tr>
          <td colspan="6"><h6>First Time Completions Metrics (first action taken on initial submissions editor completion)</h6></td>
        </tr>
        {renderStatRow(groups.ftc)}
        <tr>
          <td colspan="4"><h6>Total Submissions Metrics</h6></td>
        </tr>
        {renderStatRow(groups.totals)}
        <tr>
          <td colspan="4"><h6>Preferred Editing Deferrals</h6></td>
        </tr>
        {renderStatRow(groups.deferralRanges)}
        <tr>
          <td><h6>Approval Editing</h6></td>
        </tr>
        {renderStatRow(groups.approval)}
        <tr>
          <td><h6>Publication</h6></td>
        </tr>
        {renderStatRow(groups.publication)}
      </tbody>
    </table>
  );
};

export default IterativeStatsWidget;
